import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { SocialImg, SocialWrapper } from './styled';
import { Desktop, Mobile } from '../../MediaQuery';

const socialData = [
  {
    img: 'mkt/icon/social_facebook_white.png',
    imgDesktop: 'mkt/icon/icon_fb.png',
    title: 'Facebook',
    url: 'https://www.facebook.com/italistofficial',
  },
  {
    img: 'mkt/icon/social_instagram_white.png',
    imgDesktop: 'mkt/icon/icon_instagram.png',
    title: 'Instagram',
    url: 'https://instagram.com/italist_official',
  },
  {
    img: 'mkt/icon/social_pinterest_white.png',
    imgDesktop: 'mkt/icon/icon_pinterest.png',
    title: 'Pinterest',
    url: 'https://www.pinterest.com/italistofficial',
  },
  {
    img: 'mkt/icon/social_twitter_white.png',
    imgDesktop: 'mkt/icon/icon_twitter.png',
    title: 'Twitter',
    url: 'https://www.twitter.com/italistofficial',
  },
];

const SocialGroup = ({ s3BasePath }) => (
  <>
    <SocialWrapper>
      {socialData.map((link, index) => (
        <Fragment key={`${link.title}-${index}`}>
          <a id={`${link.title}-${index}`} href={link.url} target="_blank">
            <Mobile>
              <SocialImg src={`${s3BasePath}${link.img}`} width="20px" />
            </Mobile>
            <Desktop>
              <SocialImg index={index} src={`${s3BasePath}${link.imgDesktop}`} width="17px" />
            </Desktop>
          </a>
        </Fragment>
      ))}
    </SocialWrapper>
  </>
);

SocialGroup.propTypes = {
  s3BasePath: PropTypes.string,
};

export default SocialGroup;
